"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("../../../../../ww_project/Resources/Private/app/components/AbstractComponent"));
var fetch_1 = require("../../../../../ww_project/Resources/Private/app/utility/fetch");
var constants_1 = require("../data/constants");
var Magazines = /** @class */ (function (_super) {
    __extends(Magazines, _super);
    function Magazines() {
        var _this = _super.call(this, constants_1.DATA_MAGAZINES) || this;
        _this.filterBtnArr = [];
        _this.ajaxOffset = 170;
        if (!_this.getElement())
            return _this;
        _this.filterGroupBtn = _this.getChildElement("[".concat(constants_1.DATA_MAGAZINES_FILTER_GROUP, "]"));
        _this.filterAllBtn = _this.getChildElement("[".concat(constants_1.DATA_MAGAZINES_FILTER_ALL, "]"));
        _this.loadBtn = _this.getChildElement("[".concat(constants_1.DATA_MAGAZINES_BUTTON, "]"));
        _this.content = _this.getChildElement("[".concat(constants_1.DATA_MAGAZINES_CONTENT, "]"));
        _this.filterBtnArr.push(_this.filterGroupBtn);
        _this.filterBtnArr.push(_this.filterAllBtn);
        _this.ajaxUrl = _this.getElement().getAttribute('data-ajax-url');
        _this.ajaxDetailPage = _this.getElement().getAttribute('data-ajax-detail-page');
        _this.ajaxTargetGroup = _this.getElement().getAttribute('data-ajax-target-group');
        _this.ajaxRecordsPid = _this.getElement().getAttribute('data-ajax-records-pid');
        _this.initEventListeners();
        return _this;
    }
    Magazines.prototype.initEventListeners = function () {
        var _this = this;
        var _a, _b, _c;
        (_a = this.filterGroupBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            _this.ajaxUpdateFilter(false);
            _this.setActiveButtonState(_this.filterGroupBtn);
        });
        (_b = this.filterAllBtn) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
            _this.ajaxUpdateFilter(true);
            _this.setActiveButtonState(_this.filterAllBtn);
        });
        (_c = this.loadBtn) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            _this.ajaxList();
        });
        if (this.filterGroupBtn || this.filterAllBtn) {
            window.addEventListener('scroll', function () {
                var rect = _this.getElement().getBoundingClientRect();
                var documentHeight = rect.height;
                var currentScroll = window.scrollY + window.innerHeight;
                if (currentScroll + _this.ajaxOffset > documentHeight && !_this.isAjaxListRunning) {
                    _this.ajaxList();
                }
            });
        }
    };
    /**
     * Update filter buttons visual state
     * @private
     */
    Magazines.prototype.setActiveButtonState = function (activeBtn) {
        for (var i = 0; i < this.filterBtnArr.length; i++) {
            this.filterBtnArr[i].classList.remove(constants_1.CLASS_ACTIVE);
        }
        activeBtn.classList.add(constants_1.CLASS_ACTIVE);
    };
    /**
     * Lock/Unlock buttons on ajax filter load
     * @param isLocked
     * @private
     */
    Magazines.prototype.lockButtons = function (isLocked) {
        for (var i = 0; i < this.filterBtnArr.length; i++) {
            this.filterBtnArr[i].style.pointerEvents = isLocked ? 'none' : 'all';
        }
    };
    /**
     * Ajax call for filtering magazine results
     */
    Magazines.prototype.ajaxUpdateFilter = function (isAllGroups) {
        return __awaiter(this, void 0, void 0, function () {
            var urlTargetGroup, url, response, magazines, domParser_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.hasLoadedAllElements = false;
                        urlTargetGroup = isAllGroups ? '' : "&tx_wwmagazines_magazines[targetGroup]=".concat(this.ajaxTargetGroup);
                        url = '?tx_wwmagazines_magazines[action]=ajaxList' +
                            "&tx_wwmagazines_magazines[detailPage]=".concat(this.ajaxDetailPage) +
                            '&tx_wwmagazines_magazines[page]=0' +
                            "&tx_wwmagazines_magazines[RecordsPid]=".concat(this.ajaxRecordsPid) +
                            urlTargetGroup +
                            '&type=1677085898';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.lockButtons(true);
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(url)];
                    case 2:
                        response = _a.sent();
                        if (response.success) {
                            magazines = JSON.parse(response.magazines);
                            domParser_1 = new DOMParser();
                            this.content.innerHTML = '';
                            magazines.forEach(function (event) {
                                _this.content.appendChild(domParser_1.parseFromString(event, 'text/html').querySelector('li'));
                            });
                            if (!response.hasNext) {
                                this.loadBtn.classList.add('d-none');
                            }
                            this.ajaxUrl = response.nextUrl;
                            this.loadBtn.classList.remove('d-none');
                            this.lockButtons(false);
                        }
                        else {
                            console.log("".concat(response.errorCode, ": ").concat(response.errorMessage));
                            this.lockButtons(false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        this.lockButtons(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Ajax call to get next magazines on 'load more' button click
     */
    Magazines.prototype.ajaxList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, magazines, domParser_2, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.hasLoadedAllElements)
                            return [2 /*return*/];
                        this.isAjaxListRunning = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(this.ajaxUrl)];
                    case 2:
                        response = _a.sent();
                        if (response.success) {
                            this.isAjaxListRunning = false;
                            magazines = JSON.parse(response.magazines);
                            domParser_2 = new DOMParser();
                            magazines.forEach(function (event) {
                                _this.content.appendChild(domParser_2.parseFromString(event, 'text/html').querySelector('li'));
                            });
                            if (!response.hasNext) {
                                this.loadBtn.classList.add('d-none');
                                this.hasLoadedAllElements = true;
                                return [2 /*return*/];
                            }
                            this.ajaxUrl = response.nextUrl;
                        }
                        else {
                            console.log("".concat(response.errorCode, ": ").concat(response.errorMessage));
                            this.isAjaxListRunning = false;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.log(e_2);
                        this.isAjaxListRunning = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Magazines;
}(AbstractComponent_1.default));
exports.default = Magazines;
